import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    user: {
        isAuthenticated: false,
    },
    loading: true,
};
const slice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        updateUserInfo: (state, action) => {
            state.user = action.payload;
            state.loading = false;
        },
    },
});
export const { updateUserInfo } = slice.actions;
export default slice;
